module.exports = __webpack_public_path__ + "img/ldb-bandeau-208.316.ea47cd09.png";